export const ease = {
  entrance: [0.22, 1, 0.36, 1],
  exit: [0.4, 0, 0.2, 1],
  draw: [0.42, 0, 0.16, 1],
  spring: { type: 'spring', stiffness: 260, damping: 30 },
} as const;

export const dur = {
  micro: 0.12,
  element: 0.32,
  section: 0.64,
  cinematic: 1.2,
} as const;

export const stagger = {
  step: 0.04,
  max: 12,
} as const;

export function scaledDuration(duration: number, scale: number): number {
  return duration * scale;
}
